import React from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'
import {Button, Modal, Popover} from 'antd';
import fontColorA from '../image/fontColorA.png'

export default class SketchColor extends React.Component {
    static defaultProps  = {
        showColorEle: true
    };

    constructor(props){
        super(props);
        this.state={
            displayColorPicker: false,
        }
    }

    // 16进制转rgba
    hexToRgba(hex) {
        return {
            r: parseInt('0x' + hex.slice(1, 3)),
            g: parseInt('0x' + hex.slice(3, 5)),
            b: parseInt('0x' + hex.slice(5, 7)),
            a: hex.length>7? parseInt('0x' + hex.slice(7, 9))/255 :'1',
        };
    }

    // rgba转16进制
    rgbaTohex(color) {
        return '#'+this.numToHex(color.r)+this.numToHex(color.g)+this.numToHex(color.b)+this.numToHex(this.percentageToRgba(color.a));
    }

    numToHex(num) {
        let hex = Number(num).toString(16);
        if(hex.length==1) {
            hex = "0"+hex;
        }
        return hex
    }

    percentageToRgba(percentage) {
        let a = Math.floor(percentage*255);
        return a
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        // this.setState({ color: color.rgb });
        // let hex = color.hex + this.numToHex(this.percentageToRgba(color.hsv.s));
        let hex = this.rgbaTohex(color.rgb);
        this.props.setTooloColor(hex);
    };

    render() {
        const {toolColor}=this.props;
        let colorData=this.hexToRgba(toolColor);
        const styles = reactCSS({
            'default': {
                color: {
                    width: '8px',
                    height: '2px',
                    marginTop:1,
                    borderRadius: '2px',
                    background: `rgba(${ colorData.r }, ${ colorData.g }, ${ colorData.b }, ${ colorData.a })`,
                },
                swatch: {
                    // padding: '5px',
                    // background: '#fff',
                    // borderRadius: '1px',
                    // boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    // display: 'inline-block',
                    // cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                    right: 0,
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <div style={{position: 'relative'}}>
                <div style={ styles.swatch }   onClick={ this.handleClick }>
                    {this.props.icon}
                    {this.props.showColorEle?<div style={{...styles.color,...this.props.colorEleStyle}} />:<></>}
                </div>
                <Modal
                    visible={this.state.displayColorPicker}
                    onCancel={this.handleClose}
                    footer={null}
                    bodyStyle={{padding:'unset'}}
                    mask={false}
                    width={270}
                    closable={false}
                    style={this.props.modalEleStyle}
                >
                    <div style={styles.popover}>
                        <div style={styles.cover} onClick={this.handleClose}/>
                        <SketchPicker
                            width={270}
                            color={colorData}
                            onChange={(color)=>{
                                this.handleChange(color)
                            }}
                            // onChangeComplete={(color)=>{
                            //     console.log("onChangeComplete",color);
                            //     this.handleChange(color)
                            // }}
                        />
                    </div>
                </Modal>
            </div>
        )
    }
}
